import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27363125"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content overflow-hidden" }
const _hoisted_4 = { class: "modal-header gap-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-27363125><rect width=\"40\" height=\"40\" rx=\"10\" fill=\"#E8E8E8\" data-v-27363125></rect><g clip-path=\"url(#clip0_2159_3002)\" data-v-27363125><path opacity=\"0.3\" d=\"M29.4493 15.5508L27.6485 17.3516C27.4649 17.5352 27.168 17.5352 26.9844 17.3516L22.6485 13.0156C22.4649 12.832 22.4649 12.5352 22.6485 12.3516L24.4493 10.5508C25.1797 9.82031 26.3672 9.82031 27.1016 10.5508L29.4493 12.8984C30.1836 13.6289 30.1836 14.8164 29.4493 15.5508ZM21.1016 13.8984L10.8438 24.1562L10.0157 28.9023C9.90239 29.543 10.461 30.0977 11.1016 29.9883L15.8477 29.1562L26.1055 18.8984C26.2891 18.7148 26.2891 18.418 26.1055 18.2344L21.7696 13.8984C21.5821 13.7148 21.2852 13.7148 21.1016 13.8984ZM14.8477 23.2773C14.6329 23.0625 14.6329 22.7188 14.8477 22.5039L20.8633 16.4883C21.0782 16.2734 21.4219 16.2734 21.6368 16.4883C21.8516 16.7031 21.8516 17.0469 21.6368 17.2617L15.6211 23.2773C15.4063 23.4922 15.0626 23.4922 14.8477 23.2773ZM13.4376 26.5625H15.3126V27.9805L12.793 28.4219L11.5782 27.207L12.0196 24.6875H13.4376V26.5625Z\" fill=\"#203972\" data-v-27363125></path><path d=\"M21.1016 13.8984L10.8438 24.1562L10.0157 28.9023C9.90239 29.543 10.461 30.0977 11.1016 29.9883L15.8477 29.1562L26.1055 18.8984C26.2891 18.7148 26.2891 18.418 26.1055 18.2344L21.7696 13.8984C21.5821 13.7148 21.2852 13.7148 21.1016 13.8984ZM14.8477 23.2773C14.6329 23.0625 14.6329 22.7187 14.8477 22.5039L20.8633 16.4883C21.0782 16.2734 21.4219 16.2734 21.6368 16.4883C21.8516 16.7031 21.8516 17.0469 21.6368 17.2617L15.6211 23.2773C15.4063 23.4922 15.0626 23.4922 14.8477 23.2773ZM13.4376 26.5625H15.3126V27.9805L12.793 28.4219L11.5782 27.207L12.0196 24.6875H13.4376V26.5625Z\" fill=\"#203972\" data-v-27363125></path></g><defs data-v-27363125><clipPath id=\"clip0_2159_3002\" data-v-27363125><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(10 10)\" data-v-27363125></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = {
  class: "modal-title",
  id: "modal-quiz-label",
  style: {"color":"var(--cor_texto_1)","margin-right":"auto"}
}
const _hoisted_7 = {
  ref: "btnCloseRef",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6641 9L17.5503 4.11377C18.1499 3.51416 18.1499 2.54199 17.5503 1.94189L16.4644 0.855957C15.8647 0.256348 14.8926 0.256348 14.2925 0.855957L9.40625 5.74219L4.52002 0.855957C3.92041 0.256348 2.94824 0.256348 2.34814 0.855957L1.26221 1.94189C0.662598 2.5415 0.662598 3.51367 1.26221 4.11377L6.14844 9L1.26221 13.8862C0.662598 14.4858 0.662598 15.458 1.26221 16.0581L2.34814 17.144C2.94775 17.7437 3.92041 17.7437 4.52002 17.144L9.40625 12.2578L14.2925 17.144C14.8921 17.7437 15.8647 17.7437 16.4644 17.144L17.5503 16.0581C18.1499 15.4585 18.1499 14.4863 17.5503 13.8862L12.6641 9Z",
    fill: "#B5B5C3"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "card col-12 p-4" }
const _hoisted_12 = { class: "row g-4" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = {
  for: "form-training-post-title",
  class: "form-label cor_texto_1"
}
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "card col-12 p-4" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "el-input__inner d-flex justify-content-center align-items-center" }
const _hoisted_19 = { class: "container-checkbox" }
const _hoisted_20 = ["onClick", "onUpdate:modelValue"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row g-4" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  style: {"color":"var(--cor_icones_1)","font-size":"1.5rem"},
  "aria-hidden": "true"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  style: {"color":"var(--cor_icones_1)","font-size":"1.5rem","opacity":"0"},
  "aria-hidden": "true"
}, null, -1))
const _hoisted_30 = { class: "col-12 p-0 d-flex justify-content-end" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: `modal-quiz-${_ctx.UUID}`,
    tabindex: "-1",
    "aria-labelledby": `modal-quiz-${_ctx.UUID}`,
    "aria-hidden": "true",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.header), 1),
          _createElementVNode("button", _hoisted_7, _hoisted_9, 512)
        ]),
        (_ctx.question)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isRequiredField = false)),
              class: "modal-body",
              style: {"background-color":"var(--cor_background_2)"}
            }, [
              (_ctx.isRequiredField)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_10, "Campos obrigatórios!"))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                class: "row g-4",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, [
                        _createTextVNode("Texto da questão: "),
                        (_ctx.isRequiredField)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_15, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.question.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question.title) = $event)),
                        placeholder: "Enunciado da questão...",
                        clearable: "",
                        type: "text",
                        name: "form-training-post-title",
                        id: "form-training-post-title"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_CampTable, null, {
                    default: _withCtx(() => [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createVNode(_component_CampTableTh, {
                            class: "py-2 ps-0 pe-0",
                            style: {"border":"none"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Opções "),
                              (_ctx.isRequiredField)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_17, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CampTableTh, {
                            class: "py-2 ps-4 pe-4",
                            style: {"width":"60px","border":"none"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Correta")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CampTableTh, {
                            class: "py-2 ps-0 pe-0",
                            style: {"width":"50px","border":"none"}
                          })
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.alternatives, (alternative, id) => {
                          return (_openBlock(), _createElementBlock("tr", { key: id }, [
                            (!_ctx.question.alternatives[id].del)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_CampTableTd, { class: "py-1 ps-0 pe-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.question.alternatives[id].description,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.question.alternatives[id].description) = $event),
                                        placeholder: "Alternativa...",
                                        clearable: "",
                                        type: "text",
                                        name: "form-training-post-title",
                                        id: "form-training-post-title"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_CampTableTd, { class: "py-1 ps-4 pe-4" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("label", _hoisted_19, [
                                          _withDirectives(_createElementVNode("input", {
                                            onClick: ($event: any) => (_ctx.handleSelectionForOnlyOneItem(+id)),
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.question.alternatives[id].correct) = $event)
                                          }, null, 8, _hoisted_20), [
                                            [_vModelCheckbox, _ctx.question.alternatives[id].correct]
                                          ]),
                                          _hoisted_21
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_CampTableTd, { class: "py-1 ps-0 pe-0" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.handleDelAlternative(id)),
                                        type: "button",
                                        class: "btn btn-sm background_btn_1_opct m-0",
                                        style: {"height":"40px"}
                                      }, _hoisted_24, 8, _hoisted_22)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAlternative())),
                        disabled: _ctx.isBtnAddDisabled,
                        type: "button",
                        class: "btn background_btn_1_opct d-flex justify-content-between align-items-center w-100"
                      }, [
                        _hoisted_28,
                        _createTextVNode(" Adicionar opção "),
                        _hoisted_29
                      ], 8, _hoisted_27)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn background_btn_1",
                    style: {"color":"var(--cor_icones_1)"},
                    disabled: _ctx.isBtnConfirmDisabled
                  }, " Confirmar ", 8, _hoisted_31)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, _hoisted_1))
}